module.exports = __webpack_public_path__ + "img/wh-li-icon10.c35cdc3d.png";